<template>
  <div/>
</template>

<script setup lang="ts">
import { watch } from 'vue';
import { useStore } from 'vuex';
import { latestMessage, type WebSocketMessageWithFields, type WebSocketMessageEmpty } from '@/plugins/ws';

import {RootState} from "@/store";

const store = useStore<RootState>();

defineOptions({
  name: 'dataLanguagePageItems',
});

// Базовый тип для сообщений с ID элемента языковой страницы
type LanguagePageItemWithId = {
  idLanguagePageItem: number;
};

// Типы для WebSocket сообщений компонента languagePageItems
type LanguagePageItemsListMessage = WebSocketMessageWithFields<'language-page-item-list', {
  languagePageItems: unknown[];
}>;
type LanguagePageItemCreateMessage = WebSocketMessageWithFields<'language-page-item-create' | 'language-page-item-create-success', LanguagePageItemWithId & {
  idLanguagePage: number;
  code: string;
}>;
type LanguagePageItemDeleteMessage = WebSocketMessageWithFields<'language-page-item-delete' | 'language-page-item-delete-success', LanguagePageItemWithId>;
type LanguagePageItemListTranslationsMessage = WebSocketMessageWithFields<'language-page-item-list-translations', {
  languagePageItem: unknown;
}>;

// Объединенный тип для всех сообщений
type LanguagePageItemsWebSocketMessage = 
  | LanguagePageItemsListMessage 
  | LanguagePageItemCreateMessage 
  | LanguagePageItemDeleteMessage 
  | LanguagePageItemListTranslationsMessage;

// WebSocket message handler
const handleWebSocketMessage = (data: LanguagePageItemsWebSocketMessage): void => {
  if (!data?.signal) return;

  switch (data.signal) {
    case 'language-page-item-list':
      store.dispatch('languagePageItems/wsSetLanguagePageItems', { languagePageItems: data.languagePageItems });
      break;

    case 'language-page-item-create':
    case 'language-page-item-create-success':
      store.dispatch('languagePageItems/wsLanguagePageItemCreate', {
        idLanguagePageItem: data.idLanguagePageItem,
        idLanguagePage: data.idLanguagePage,
        code: data.code,
      });
      break;

    case 'language-page-item-delete':
    case 'language-page-item-delete-success':
      store.dispatch('languagePageItems/wsLanguagePageItemDelete', { idLanguagePageItem: data.idLanguagePageItem });
      break;

    case 'language-page-item-list-translations':
      store.dispatch('languagePageItem/wsSetLanguagePageItem', data.languagePageItem);
      break;
  }
};

watch(latestMessage, handleWebSocketMessage);
</script>
